<template>
  <div class="page-container">
    <div>
      <el-button v-if="!noContent" type="primary" :disabled="addBtnLoading" @click="addOrUpdateHandle()">Add Commission</el-button>
    </div>
    <div class="el-list protocols-wrapper">
      <el-row v-loading="dataListLoading" :gutter="30">
        <el-col v-if="noContent">
          <el-empty description=" ">
            <el-button type="primary" @click="addOrUpdateHandle()">Add Commission</el-button>
          </el-empty>
        </el-col>
        <template v-if="!noContent">
          <el-col :span="6" v-for="item in dataList" :key="item.id">
            <el-card shadow="nerver" :body-style="{ padding: '0px' }" class="mt16 relative">
              <div class="module-item">
                <div class="module-desc">
                  <p class="item-wrap">
                    <span class="wd132 item-label">Name:</span>
                    <span class="item-content">{{ item.name }}</span>
                  </p>
                  <p class="item-wrap">
                    <span class="wd132 item-label">Commission Rate:</span>
                    <span class="item-content">{{ item.commissionRate | percentage }}</span>
                  </p>
                  <p class="item-wrap">
                    <span class="wd132 item-label">Supplier:</span>
                    <span class="item-content">{{ item.supplier?.abbr || "" }}</span>
                  </p>
                  <p class="item-wrap">
                    <span class="wd132 item-label">Contact Info:</span>
                    <span class="item-content">{{ item.contact }}</span>
                  </p>
                  <p class="item-wrap">
                    <span class="wd132 item-label">Update Time:</span>
                    <span class="item-content">{{ item.updateTime }}</span>
                  </p>
                </div>
              </div>
              <ul class="el-card-actions">
                <li class="wdb50" @click="deleteHandle(item.id)">
                  <svg-icon name="delete" class="fs16"></svg-icon>
                </li>
                <li class="wdb50" @click="addOrUpdateHandle(item)">
                  <svg-icon name="edit" class="fs16"></svg-icon>
                </li>
              </ul>
            </el-card>
          </el-col>
        </template>
      </el-row>
    </div>

    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update ref="addOrUpdate" :supplierList="supplierList" @refreshDataList="getDataList"></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from "./modal/AddOrUpdate";
import filtersMixin from "@/mixins/filtersMixin";
import { mapState } from "vuex";
export default {
  mixins: [filtersMixin],
  components: {
    AddOrUpdate,
  },
  data() {
    return {
      dataForm: {},
      dataList: [],
      supplierList: [],
      dataListLoading: false,
      addBtnLoading: false,
    };
  },
  computed: {
    ...mapState("constant", ["countryList"]),
    noContent() {
      return this.dataList.length === 0;
    },
  },
  methods: {
    // 获取供应商列表
    getSupplierList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplier")
          .then(res => {
            this.supplierList = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取数据列表
    async getDataList() {
      this.dataListLoading = true;
      const { data } = await this.$http.get("/admin/stCommission/getList");
      this.dataList = data;
      this.dataListLoading = false;
    },
    // 新增 / 修改
    addOrUpdateHandle(data) {
      this.$refs.addOrUpdate.init(data);
    },
    // 删除
    async deleteHandle(id) {
      await this.$confirm(`Delete this Commission Required. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      this.$http
        .post(`/admin/stCommission/${id}/delete`)
        .then(res => {
          this.$message({
            message: "success",
            type: "success",
            duration: 1500,
            onClose: () => this.getDataList(),
          });
        })
        .catch(err => {});
    },
  },
  async activated() {
    try {
      this.addBtnLoading = true;
      this.dataListLoading = true;
      await this.getSupplierList();
    } catch (error) {
    } finally {
      this.addBtnLoading = false;
      this.getDataList();
    }
  },
};
</script>

<style lang="scss" scoped></style>
